import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
// Material
import Chip from '@mui/material/Chip'
// Components
import Autocomplete from '../Autocomplete'
// Hooks
import useConcepts from '../../../hooks/orders/useConcepts'

const RenderTags = (value, getTagProps) =>
    value.map((option, index) => {
        return <Chip key={index} label={`${option?.description}`} {...getTagProps({ index })} />
    })

const AutocompleteConcepts = ({ multiple, type, value, getOptionValue, disabled,  ...rest }) => {
    const { concepts, loading } = useConcepts();

    const options = useMemo(() => concepts
        ?.filter(b => {
            if (!type)
                return true;

            return b.type === type;
        })
        , [concepts, type]);

    const selected = useMemo(() => {
        if (!value || !concepts || concepts.length === 0)
            return multiple ? [] : '';

        if (multiple)
            return Array.isArray(value)
                ? concepts?.filter(b => value && value.some(v => getOptionValue(b) === v.id))
                : [concepts?.find(b => getOptionValue(b) === value.id)];

        return concepts?.find(b => getOptionValue(b) === value?.id)
    }, [multiple, concepts, value, getOptionValue])

    return (
        <Autocomplete
            size='small'
            name='concepts'
            label='Motivos'
            placeholder='Ej.: Falla'
            getOptionValue={getOptionValue}
            {...rest}
            multiple={multiple}
            value={selected}
            options={options}
            disabled={disabled || loading || concepts.length === 0}
            data-testid='concepts-autocomplete'
            renderTags={multiple && RenderTags}
        />
    )
}

AutocompleteConcepts.defaultProps = {
    getOptionValue: (option) => option?.id || option,
    getOptionLabel: (option) => option ? `${option?.description}` : option
}

AutocompleteConcepts.prototype = {
    getOptionValue: PropTypes.func,
    getOptionLabel: PropTypes.func
}

export default AutocompleteConcepts;